<template>
  <div class="page">
    <div class="nav-wrapper">
      <Navbar />
    </div>
    <div class="page-wrapper">
      <div class="filter-wrapper">
        <div class="filter-container filter-container--auto">
          <SearchInput sort-key="search" @update-search-value="filterClients" />
        </div>
      </div>
      <div class="list-container">
        <List :headers="headers">
          <tr v-for="(item, i) in clients" :key="i" class="list__line">
            <td>{{ item.firstName }}</td>
            <td>{{ item.lastName }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.phoneNumber }}</td>
            <td>{{ $t(item.estimation.status) }}</td>
            <td>
              <button
                type="button"
                class="button button--active"
                @click="fullView(item.estimation)"
              >
                {{ $t('show_estimation') }}
              </button>
            </td>
          </tr>
        </List>
      </div>
      <InfiniteScroll
        v-if="clients.length < totalClients"
        :items-per-page="30"
        @paginate="paginateClients"
      />
    </div>
  </div>
</template>

<script>
import Navbar from '../../components/Navbar';
import List from '../../components/List';
import { SearchInput, InfiniteScroll } from '../../components/filters';
import { ClientComponent } from '../../mixins';

export default {
  components: { Navbar, List, SearchInput, InfiniteScroll },

  mixins: [ClientComponent],

  data() {
    return {
      headers: [
        'first_name',
        'last_name',
        'email',
        'phone_number',
        'estimation_status',
        'action',
      ],
    };
  },

  async created() {
    const clients = await this.fetchClients();

    if (!clients || !clients['hydra:member']) return;

    this.clients = clients['hydra:member'];

    if (!clients['hydra:totalItems']) return;

    this.totalClients = clients['hydra:totalItems'];
  },
};
</script>
